/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  TERMINATE_WP_SUCCESS: {
    message: 'Work Permit Terminated successfully',
  },
  TERMINATE_WP_ERROR: {
    message: 'Failed to terminate work permit',
  },
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.jamaica.terminateWorkPermit',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        MUTATE: { target: 'INITIATE_TERMINATE_WP' },
      },
    },
    INITIATE_TERMINATE_WP: {
      invoke: {
        id: 'terminateWorkPermit',
        src: 'terminateWorkPermit',
        onDone: {
          target: 'TERMINATE_WP_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'TERMINATE_WP_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    TERMINATE_WP_SUCCESS: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_TERMINATE_WP' },
      },
    },
    TERMINATE_WP_ERROR: {
      //type: "final",
      on: {
        MUTATE: { target: 'INITIATE_TERMINATE_WP' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
